var _rect, _mask, _g, _path, _path2, _path3, _path4, _path5, _path6, _mask2, _g2, _mask3, _g3, _mask4, _g4, _mask5, _g5, _mask6, _g6, _mask7, _g7, _mask8, _g8, _mask9, _g9, _mask10, _g10, _mask11, _g11, _mask12, _g12, _mask13, _g13, _mask14, _g14, _mask15, _g15, _mask16, _g16, _mask17, _g17, _mask18, _g18, _mask19, _g19, _mask20, _g20, _mask21, _g21, _mask22, _g22, _mask23, _g23;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 50,
    viewBox: "0 0 152 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.50293,
    width: 151,
    height: 48,
    rx: 23.5,
    stroke: "#929292"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 22,
    width: 91,
    height: 19
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8047 22.0283H137.827V40.0034H47.8047V22.0283Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9214 30.2764V28.3722H61.3713C61.4393 28.7121 61.4733 29.1195 61.4733 29.5618C61.4733 30.99 61.0804 32.7591 59.8135 34.0173C58.5828 35.2935 57.008 35.9733 54.9214 35.9733C51.0551 35.9733 47.8047 32.8435 47.8047 29.0013C47.8047 25.158 51.0551 22.0283 54.9214 22.0283C57.0601 22.0283 58.5828 22.8622 59.7286 23.9494L58.3768 25.2942C57.556 24.5279 56.4442 23.9336 54.9214 23.9336C52.0989 23.9336 49.8924 26.1946 49.8924 29.0013C49.8924 31.807 52.0989 34.068 54.9214 34.068C56.7521 34.068 57.796 33.3375 58.4628 32.6736C59.0108 32.1289 59.3697 31.3478 59.5067 30.2764H54.9214ZM91.9653 35.7009H93.9489V22.5044H91.9653V35.7009ZM107.581 22.5054H112.329C114.525 22.5054 116.685 24.0856 116.685 26.6031C116.685 29.1206 114.525 30.7018 112.329 30.7018H109.563V35.7009H107.581V22.5054ZM119.758 35.7009H117.778V22.5054H119.758V35.7009ZM133.353 32.9797L135.625 27.2586H137.828L132.38 39.7025H130.313L132.329 35.2544L128.794 27.2586H130.928L133.284 32.9797H133.353ZM124.387 34.202C123.738 34.202 122.833 33.8801 122.833 33.0821C122.833 32.0635 123.96 31.6729 124.934 31.6729C125.804 31.6729 126.214 31.8598 126.743 32.1142C126.59 33.3365 125.531 34.202 124.387 34.202ZM121.091 28.9908C121.705 27.5974 123.192 26.9704 124.626 26.9704C126.897 26.9704 128.657 28.2772 128.657 30.6205V35.6788H126.743V34.6602H126.675C126.214 35.3568 125.479 35.9511 124.148 35.9511C122.405 35.9511 120.851 34.8122 120.851 33.0483C120.851 31.1124 122.781 30.0769 124.677 30.0769C125.616 30.0769 126.384 30.382 126.743 30.5868V30.4506C126.727 29.3634 125.684 28.7522 124.66 28.7522C123.926 28.7522 123.226 28.9908 122.849 29.7202L121.091 28.9908ZM112.381 28.8652H109.563V24.3421H112.381C113.861 24.3421 114.702 25.5613 114.702 26.6031C114.702 27.6259 113.861 28.8652 112.381 28.8652ZM86.4392 34.2042C85.0705 34.2042 83.9247 33.0652 83.9247 31.5009C83.9247 29.9197 85.0705 28.7628 86.4392 28.7628C87.791 28.7628 88.8518 29.9197 88.8518 31.5009C88.8518 33.0652 87.791 34.2042 86.4392 34.2042ZM88.6458 27.9975H88.7148V27.266H90.5965V35.3273C90.5965 38.6428 88.6299 40.0034 86.3022 40.0034C84.1126 40.0034 82.7959 38.5414 82.3 37.3508L84.0277 36.6362C84.3356 37.3677 85.0885 38.2353 86.3022 38.2353C87.791 38.2353 88.7148 37.3159 88.7148 35.5996V34.9525H88.6458C88.2009 35.4972 87.3461 35.9733 86.2683 35.9733C84.0096 35.9733 81.94 34.0173 81.94 31.5009C81.94 28.9665 84.0096 26.9937 86.2683 26.9937C87.3461 26.9937 88.2009 27.4697 88.6458 27.9975ZM99.236 28.729C98.2272 28.729 96.8244 29.6135 96.8744 31.3478L100.913 29.6811C100.69 29.1195 100.023 28.729 99.236 28.729ZM103.033 29.851C102.657 28.8472 101.512 26.9937 99.168 26.9937C96.8404 26.9937 94.9077 28.8134 94.9077 31.4829C94.9077 34.0004 96.8245 35.9733 99.39 35.9733C101.46 35.9733 102.657 34.715 103.153 33.9835L101.614 32.9628C101.101 33.7112 100.4 34.2042 99.39 34.2042C98.3801 34.2042 97.6623 33.746 97.2004 32.8435L103.239 30.3619L103.033 29.851ZM66.6861 34.2042C65.3173 34.2042 64.1365 33.0821 64.1365 31.4829C64.1365 29.8679 65.3173 28.7628 66.6861 28.7628C68.0548 28.7628 69.2346 29.8679 69.2346 31.4829C69.2346 33.0821 68.0548 34.2042 66.6861 34.2042ZM62.1529 31.4829C62.1529 28.881 64.1885 26.9937 66.6861 26.9937C69.1836 26.9937 71.2192 28.881 71.2192 31.4829C71.2192 34.068 69.1836 35.9733 66.6861 35.9733C64.1885 35.9733 62.1529 34.068 62.1529 31.4829ZM76.5754 34.2042C75.2077 34.2042 74.0269 33.0821 74.0269 31.4829C74.0269 29.8679 75.2077 28.7628 76.5754 28.7628C77.9441 28.7628 79.125 29.8679 79.125 31.4829C79.125 33.0821 77.9441 34.2042 76.5754 34.2042ZM72.0422 31.4829C72.0422 28.881 74.0778 26.9937 76.5754 26.9937C79.074 26.9937 81.1096 28.881 81.1096 31.4829C81.1096 34.068 79.074 35.9733 76.5754 35.9733C74.0778 35.9733 72.0422 34.068 72.0422 31.4829Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 36.6683C15 37.336 15.0961 37.7474 15.408 38.0791L15.4946 38.1814L28.2661 24.8324L15.3749 11.4834C15.0641 11.8151 15 12.1834 15 12.8511V36.6683Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8789 24.7724L33.2079 29.1415L38.3247 26.1468C39.8374 25.2734 39.8374 23.8445 38.3247 22.9711L33.2079 19.8408L28.8789 24.7724Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7256 38.4102C16.2009 38.7763 16.8595 38.7149 17.6604 38.2476V38.2476L32.9556 29.3091L28.5657 25.0283L15.7256 38.4102Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5247 24.4112L32.8533 19.7051L17.6443 11.3468C17.2354 11.1128 16.8479 11.0029 16.5041 11.0029C16.1685 11.0029 15.8745 11.1076 15.6416 11.3047L28.5247 24.4112Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2549 11.0596V17.4734H50.2005C51.1781 17.4734 51.9605 17.1762 52.5469 16.5818C53.1332 15.9886 53.4258 15.2157 53.4258 14.2665C53.4258 13.3172 53.1332 12.5454 52.5469 11.9511C51.9605 11.3567 51.1781 11.0596 50.2005 11.0596H48.2549ZM50.2005 16.6855H49.0724V11.8485H50.2005C50.9353 11.8485 51.5173 12.0623 51.9468 12.4888C52.3762 12.9164 52.5903 13.5086 52.5903 14.2665C52.5903 15.0308 52.3762 15.6251 51.9468 16.0495C51.5173 16.4739 50.9353 16.6855 50.2005 16.6855Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0724 16.6855H48.9724V16.7855H49.0724V16.6855ZM51.9468 12.4888L52.0173 12.4179L52.0172 12.4178L51.9468 12.4888ZM49.0724 11.8485V11.7485H48.9724V11.8485H49.0724ZM48.2549 17.4734H48.1549V17.5734H48.2549V17.4734ZM48.2549 11.0596V10.9596H48.1549V11.0596H48.2549ZM52.5469 11.9511L52.6181 11.8809L52.6181 11.8809L52.5469 11.9511ZM52.5469 16.5818L52.4757 16.5116L52.4757 16.5116L52.5469 16.5818ZM49.0724 16.7855H50.2005V16.5855H49.0724V16.7855ZM50.2005 16.7855C50.9554 16.7855 51.565 16.5674 52.0171 16.1206L51.8765 15.9784C51.4697 16.3803 50.9151 16.5855 50.2005 16.5855V16.7855ZM52.0171 16.1206C52.4702 15.6727 52.6903 15.0499 52.6903 14.2665H52.4903C52.4903 15.0116 52.2821 15.5775 51.8765 15.9784L52.0171 16.1206ZM52.6903 14.2665C52.6903 13.4891 52.4701 12.8687 52.0173 12.4179L51.8762 12.5596C52.2823 12.964 52.4903 13.5281 52.4903 14.2665H52.6903ZM52.0172 12.4178C51.5652 11.9689 50.9557 11.7485 50.2005 11.7485V11.9485C50.9148 11.9485 51.4695 12.1556 51.8763 12.5597L52.0172 12.4178ZM50.2005 11.7485H49.0724V11.9485H50.2005V11.7485ZM48.9724 11.8485V16.6855H49.1724V11.8485H48.9724ZM48.3549 17.4734V11.0596H48.1549V17.4734H48.3549ZM48.2549 11.1596H50.2005V10.9596H48.2549V11.1596ZM50.2005 11.1596C51.1563 11.1596 51.9114 11.4493 52.4757 12.0213L52.6181 11.8809C52.0097 11.2642 51.1999 10.9596 50.2005 10.9596V11.1596ZM52.4757 12.0213C53.041 12.5943 53.3258 13.3396 53.3258 14.2665H53.5258C53.5258 13.2949 53.2255 12.4966 52.6181 11.8809L52.4757 12.0213ZM53.3258 14.2665C53.3258 15.1934 53.0409 15.9397 52.4757 16.5116L52.618 16.6521C53.2255 16.0375 53.5258 15.238 53.5258 14.2665H53.3258ZM52.4757 16.5116C51.9114 17.0837 51.1563 17.3734 50.2005 17.3734V17.5734C51.1999 17.5734 52.0097 17.2687 52.6181 16.6521L52.4757 16.5116ZM50.2005 17.3734H48.2549V17.5734H50.2005V17.3734Z",
    fill: "white"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 123,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 40.0032H137.828V9.30469H15V40.0032Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.5735 17.4734H55.391V11.0596H54.5735V17.4734Z",
    fill: "white"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 123,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 40.0032H137.828V9.30469H15V40.0032Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5735 17.4734H55.391V11.0596H54.5735V17.4734Z",
    stroke: "white",
    strokeWidth: 0.2
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 123,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 40.0032H137.828V9.30469H15V40.0032Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.6422 17.6163C58.1799 17.6163 57.7293 17.4645 57.2882 17.1598C56.8461 16.8552 56.5566 16.4287 56.4209 15.8792L57.1673 15.5746C57.2564 15.9263 57.4377 16.2234 57.7134 16.465C57.9901 16.7066 58.2986 16.8285 58.6422 16.8285C58.9974 16.8285 59.3017 16.7344 59.5529 16.5463C59.8053 16.3581 59.9304 16.1026 59.9304 15.7798C59.9304 15.4217 59.8053 15.1459 59.5529 14.9514C59.3017 14.7579 58.903 14.5772 58.358 14.4094C57.795 14.2309 57.3688 13.9989 57.0783 13.7156C56.7888 13.4313 56.6425 13.0689 56.6425 12.6274C56.6425 12.1667 56.8238 11.7669 57.1854 11.427C57.5469 11.0871 58.0177 10.916 58.5976 10.916C59.1373 10.916 59.5752 11.0518 59.9124 11.3233C60.2506 11.5959 60.4701 11.8931 60.5698 12.2148L59.8244 12.528C59.7703 12.326 59.6388 12.1378 59.4289 11.9636C59.219 11.7915 58.9475 11.7049 58.6157 11.7049C58.3018 11.7049 58.0336 11.7926 57.812 11.9689C57.5893 12.1453 57.478 12.3645 57.478 12.6274C57.478 12.8658 57.5808 13.0678 57.7844 13.2314C57.9901 13.396 58.2902 13.5435 58.6867 13.675C59.0005 13.7766 59.2624 13.8749 59.4734 13.9711C59.6834 14.0663 59.8975 14.1935 60.1128 14.3517C60.3291 14.5099 60.4913 14.7066 60.6016 14.9428C60.7108 15.1791 60.7659 15.4516 60.7659 15.7627C60.7659 16.0727 60.7023 16.3506 60.5751 16.5954C60.4478 16.8402 60.2782 17.0348 60.0682 17.178C59.8572 17.3213 59.6325 17.4303 59.3886 17.5051C59.1458 17.5789 58.8966 17.6163 58.6422 17.6163",
    fill: "white"
  }))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "mask4",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 123,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 40.0032H137.828V9.30469H15V40.0032Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6422 17.6163C58.1799 17.6163 57.7293 17.4645 57.2882 17.1598C56.8461 16.8552 56.5566 16.4287 56.4209 15.8792L57.1673 15.5746C57.2564 15.9263 57.4377 16.2234 57.7134 16.465C57.9901 16.7066 58.2986 16.8285 58.6422 16.8285C58.9974 16.8285 59.3017 16.7344 59.5529 16.5463C59.8053 16.3581 59.9304 16.1026 59.9304 15.7798C59.9304 15.4217 59.8053 15.1459 59.5529 14.9514C59.3017 14.7579 58.903 14.5772 58.358 14.4094C57.795 14.2309 57.3688 13.9989 57.0783 13.7156C56.7888 13.4313 56.6425 13.0689 56.6425 12.6274C56.6425 12.1667 56.8238 11.7669 57.1854 11.427C57.5469 11.0871 58.0177 10.916 58.5976 10.916C59.1373 10.916 59.5752 11.0518 59.9124 11.3233C60.2506 11.5959 60.4701 11.8931 60.5698 12.2148L59.8244 12.528C59.7703 12.326 59.6388 12.1378 59.4289 11.9636C59.219 11.7915 58.9475 11.7049 58.6157 11.7049C58.3018 11.7049 58.0336 11.7926 57.812 11.9689C57.5893 12.1453 57.478 12.3645 57.478 12.6274C57.478 12.8658 57.5808 13.0678 57.7844 13.2314C57.9901 13.396 58.2902 13.5435 58.6867 13.675C59.0005 13.7766 59.2624 13.8749 59.4734 13.9711C59.6834 14.0663 59.8975 14.1935 60.1128 14.3517C60.3291 14.5099 60.4913 14.7066 60.6016 14.9428C60.7108 15.1791 60.7659 15.4516 60.7659 15.7627C60.7659 16.0727 60.7023 16.3506 60.5751 16.5954C60.4478 16.8402 60.2782 17.0348 60.0682 17.178C59.8572 17.3213 59.6325 17.4303 59.3886 17.5051C59.1458 17.5789 58.8966 17.6163 58.6422 17.6163Z",
    stroke: "white",
    strokeWidth: 0.2
  }))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "mask5",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 123,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 40.0032H137.828V9.30469H15V40.0032Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9385 17.4734H62.7559V14.8758H64.1067C64.6454 14.8758 65.1129 14.6951 65.5063 14.3327C65.9007 13.9725 66.0969 13.5171 66.0969 12.9677C66.0969 12.4182 65.9007 11.9628 65.5063 11.6015C65.1129 11.2402 64.6454 11.0596 64.1067 11.0596H61.9385V17.4734ZM64.1248 14.0869H62.7559V11.8474H64.1248C64.4683 11.8474 64.744 11.9639 64.9507 12.1969C65.1585 12.43 65.2614 12.6865 65.2614 12.9677C65.2614 13.2488 65.1585 13.5054 64.9507 13.7384C64.744 13.9714 64.4683 14.0869 64.1248 14.0869Z",
    fill: "white"
  }))), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "mask6",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 123,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 40.0032H137.828V9.30469H15V40.0032Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.7559 14.0869H62.6559V14.1869H62.7559V14.0869ZM64.9507 13.7384L64.8761 13.6718L64.8759 13.672L64.9507 13.7384ZM64.9507 12.1969L64.8759 12.2633L64.8761 12.2635L64.9507 12.1969ZM62.7559 11.8474V11.7474H62.6559V11.8474H62.7559ZM62.7559 17.4734V17.5734H62.8559V17.4734H62.7559ZM61.9385 17.4734H61.8385V17.5734H61.9385V17.4734ZM61.9385 11.0596V10.9596H61.8385V11.0596H61.9385ZM65.5063 11.6015L65.4387 11.6752L65.4388 11.6753L65.5063 11.6015ZM65.5063 14.3327L65.4389 14.2589L65.4385 14.2592L65.5063 14.3327ZM62.7559 14.8758V14.7758H62.6559V14.8758H62.7559ZM62.7559 14.1869H64.1248V13.9869H62.7559V14.1869ZM64.1248 14.1869C64.4933 14.1869 64.7975 14.0617 65.0255 13.8048L64.8759 13.672C64.6904 13.8811 64.4433 13.9869 64.1248 13.9869V14.1869ZM65.0254 13.805C65.2477 13.5556 65.3614 13.2759 65.3614 12.9677H65.1614C65.1614 13.2217 65.0694 13.4551 64.8761 13.6718L65.0254 13.805ZM65.3614 12.9677C65.3614 12.6594 65.2477 12.3797 65.0254 12.1304L64.8761 12.2635C65.0694 12.4802 65.1614 12.7137 65.1614 12.9677H65.3614ZM65.0255 12.1306C64.7977 11.8738 64.4935 11.7474 64.1248 11.7474V11.9474C64.443 11.9474 64.6902 12.0541 64.8759 12.2633L65.0255 12.1306ZM64.1248 11.7474H62.7559V11.9474H64.1248V11.7474ZM62.6559 11.8474V14.0869H62.8559V11.8474H62.6559ZM62.7559 17.3734H61.9385V17.5734H62.7559V17.3734ZM62.0385 17.4734V11.0596H61.8385V17.4734H62.0385ZM61.9385 11.1596H64.1067V10.9596H61.9385V11.1596ZM64.1067 11.1596C64.6206 11.1596 65.064 11.331 65.4387 11.6752L65.5739 11.5279C65.1619 11.1494 64.6701 10.9596 64.1067 10.9596V11.1596ZM65.4388 11.6753C65.8118 12.017 65.9969 12.4453 65.9969 12.9677H66.1969C66.1969 12.3912 65.9897 11.9087 65.5738 11.5278L65.4388 11.6753ZM65.9969 12.9677C65.9969 13.4901 65.8118 13.9183 65.4389 14.2589L65.5737 14.4066C65.9897 14.0267 66.1969 13.5441 66.1969 12.9677H65.9969ZM65.4385 14.2592C65.0639 14.6043 64.6206 14.7758 64.1067 14.7758V14.9758C64.6701 14.9758 65.162 14.7859 65.5741 14.4063L65.4385 14.2592ZM64.1067 14.7758H62.7559V14.9758H64.1067V14.7758ZM62.6559 14.8758V17.4734H62.8559V14.8758H62.6559Z",
    fill: "white"
  }))), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "mask7",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 123,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 40.0032H137.828V9.30469H15V40.0032Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9964 17.6173C70.9262 17.6173 71.7034 17.2934 72.329 16.6445C72.9535 15.9967 73.2663 15.2046 73.2663 14.2671C73.2663 13.335 72.9524 12.544 72.3247 11.893C71.696 11.242 70.9209 10.917 69.9964 10.917C69.0665 10.917 68.2893 11.2409 67.6648 11.8887C67.0393 12.5365 66.7275 13.3296 66.7275 14.2671C66.7275 15.2046 67.0393 15.9967 67.6648 16.6445C68.2893 17.2934 69.0665 17.6173 69.9964 17.6173ZM69.9964 16.8284C69.3146 16.8284 68.7389 16.5889 68.2681 16.1079C67.7984 15.6269 67.562 15.0133 67.562 14.2671C67.562 13.521 67.7984 12.9063 68.2681 12.4264C68.7389 11.9453 69.3146 11.7048 69.9964 11.7048C70.6771 11.7048 71.2539 11.9453 71.7246 12.4264C72.1954 12.9063 72.4318 13.521 72.4318 14.2671C72.4318 15.0133 72.1954 15.6269 71.7246 16.1079C71.2539 16.5889 70.6771 16.8284 69.9964 16.8284Z",
    fill: "white"
  }))), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "mask8",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 123,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 40.0032H137.828V9.30469H15V40.0032Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.2681 16.1079L68.1966 16.1778L68.1966 16.1778L68.2681 16.1079ZM71.7246 12.4264L71.6531 12.4963L71.6532 12.4964L71.7246 12.4264ZM68.2681 12.4264L68.1966 12.3564L68.1966 12.3564L68.2681 12.4264ZM72.329 16.6445L72.401 16.7139L72.401 16.7139L72.329 16.6445ZM67.6648 16.6445L67.7369 16.5752L67.7368 16.575L67.6648 16.6445ZM67.6648 11.8887L67.7368 11.9581L67.7368 11.9581L67.6648 11.8887ZM72.3247 11.893L72.3967 11.8235L72.3967 11.8235L72.3247 11.893ZM68.1966 16.1778C68.6866 16.6784 69.2882 16.9284 69.9964 16.9284V16.7284C69.341 16.7284 68.7912 16.4994 68.3396 16.0379L68.1966 16.1778ZM69.9964 16.9284C70.7035 16.9284 71.3062 16.6784 71.7961 16.1778L71.6531 16.0379C71.2015 16.4994 70.6507 16.7284 69.9964 16.7284V16.9284ZM71.7961 16.1778C72.2871 15.6761 72.5318 15.0364 72.5318 14.2671H72.3318C72.3318 14.9901 72.1036 15.5776 71.6531 16.0379L71.7961 16.1778ZM72.5318 14.2671C72.5318 13.4979 72.2872 12.8571 71.796 12.3563L71.6532 12.4964C72.1036 12.9556 72.3318 13.5441 72.3318 14.2671H72.5318ZM71.7961 12.3564C71.3062 11.8559 70.7036 11.6048 69.9964 11.6048V11.8048C70.6506 11.8048 71.2015 12.0348 71.6531 12.4963L71.7961 12.3564ZM69.9964 11.6048C69.2881 11.6048 68.6865 11.8559 68.1966 12.3564L68.3396 12.4963C68.7913 12.0348 69.3411 11.8048 69.9964 11.8048V11.6048ZM68.1966 12.3564C67.7066 12.8572 67.462 13.4979 67.462 14.2671H67.662C67.662 13.5441 67.8902 12.9555 68.3396 12.4963L68.1966 12.3564ZM67.462 14.2671C67.462 15.0364 67.7067 15.676 68.1966 16.1778L68.3397 16.038C67.8902 15.5777 67.662 14.9901 67.662 14.2671H67.462ZM72.257 16.5751C71.6509 17.2037 70.9001 17.5173 69.9964 17.5173V17.7173C70.9524 17.7173 71.7559 17.383 72.401 16.7139L72.257 16.5751ZM69.9964 17.5173C69.0927 17.5173 68.3418 17.2037 67.7369 16.5752L67.5928 16.7139C68.2368 17.383 69.0404 17.7173 69.9964 17.7173V17.5173ZM67.7368 16.575C67.13 15.9468 66.8275 15.1799 66.8275 14.2671H66.6275C66.6275 15.2293 66.9485 16.0467 67.5929 16.714L67.7368 16.575ZM66.8275 14.2671C66.8275 13.3543 67.1301 12.5864 67.7368 11.9581L67.5929 11.8192C66.9485 12.4866 66.6275 13.305 66.6275 14.2671H66.8275ZM67.7368 11.9581C68.3418 11.3306 69.0926 11.017 69.9964 11.017V10.817C69.0404 10.817 68.2369 11.1512 67.5928 11.8193L67.7368 11.9581ZM69.9964 11.017C70.8944 11.017 71.6433 11.3314 72.2528 11.9624L72.3967 11.8235C71.7486 11.1525 70.9474 10.817 69.9964 10.817V11.017ZM72.2527 11.9624C72.8619 12.5941 73.1663 13.36 73.1663 14.2671H73.3663C73.3663 13.31 73.043 12.4938 72.3967 11.8235L72.2527 11.9624ZM73.1663 14.2671C73.1663 15.1799 72.8627 15.9468 72.257 16.5751L72.401 16.7139C73.0442 16.0467 73.3663 15.2294 73.3663 14.2671H73.1663Z",
    fill: "white"
  }))), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "mask9",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 123,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 40.0032H137.828V9.30469H15V40.0032Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.4141 17.4734V11.0596H75.4086L78.5004 16.0484H78.5364L78.5004 14.8127V11.0596H79.3189V17.4734H78.4654L75.2315 12.2418H75.1955L75.2315 13.4786V17.4734H74.4141Z",
    fill: "white"
  }))), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "mask10",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 123,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 40.0032H137.828V9.30469H15V40.0032Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.4141 17.4734V11.0596H75.4086L78.5004 16.0484H78.5364L78.5004 14.8127V11.0596H79.3189V17.4734H78.4654L75.2315 12.2418H75.1955L75.2315 13.4786V17.4734H74.4141Z",
    stroke: "white",
    strokeWidth: 0.2
  }))), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "mask11",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 123,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 40.0032H137.828V9.30469H15V40.0032Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.8284 10.5581H81.5398L82.1803 9.41113H81.2917L80.8284 10.5581ZM81.5929 17.4733H80.7754V11.0595H81.5929V17.4733Z",
    fill: "white"
  }))), _mask13 || (_mask13 = /*#__PURE__*/React.createElement("mask", {
    id: "mask12",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 123,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 40.0032H137.828V9.30469H15V40.0032Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.5398 10.5581V10.6581H81.5985L81.6272 10.6069L81.5398 10.5581ZM80.8284 10.5581L80.7357 10.5207L80.6802 10.6581H80.8284V10.5581ZM81.2917 9.41113V9.31113H81.2243L81.199 9.37368L81.2917 9.41113ZM82.1803 9.41113L82.2676 9.45988L82.3506 9.31113H82.1803V9.41113ZM80.7754 17.4733H80.6754V17.5733H80.7754V17.4733ZM81.5929 17.4733V17.5733H81.6929V17.4733H81.5929ZM81.5929 11.0595H81.6929V10.9595H81.5929V11.0595ZM80.7754 11.0595V10.9595H80.6754V11.0595H80.7754ZM81.5398 10.4581H80.8284V10.6581H81.5398V10.4581ZM80.9211 10.5956L81.3845 9.44859L81.199 9.37368L80.7357 10.5207L80.9211 10.5956ZM81.2917 9.51113H82.1803V9.31113H81.2917V9.51113ZM82.0929 9.36238L81.4525 10.5094L81.6272 10.6069L82.2676 9.45988L82.0929 9.36238ZM80.7754 17.5733H81.5929V17.3733H80.7754V17.5733ZM81.6929 17.4733V11.0595H81.4929V17.4733H81.6929ZM81.5929 10.9595H80.7754V11.1595H81.5929V10.9595ZM80.6754 11.0595V17.4733H80.8754V11.0595H80.6754Z",
    fill: "white"
  }))), _mask14 || (_mask14 = /*#__PURE__*/React.createElement("mask", {
    id: "mask13",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 123,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 40.0032H137.828V9.30469H15V40.0032Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.622 17.4734L82.3838 11.0596H83.2893L85.0313 16.2644H85.0663L86.8794 11.0596H87.7848L85.4756 17.4734H84.622Z",
    fill: "white"
  }))), _mask15 || (_mask15 = /*#__PURE__*/React.createElement("mask", {
    id: "mask14",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 123,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 40.0032H137.828V9.30469H15V40.0032Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.622 17.4734L82.3838 11.0596H83.2893L85.0313 16.2644H85.0663L86.8794 11.0596H87.7848L85.4756 17.4734H84.622Z",
    stroke: "white",
    strokeWidth: 0.2
  }))), _mask16 || (_mask16 = /*#__PURE__*/React.createElement("mask", {
    id: "mask15",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 123,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 40.0032H137.828V9.30469H15V40.0032Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.4241 11.8474H89.5274V13.8806H92.1389V14.6513H89.5274V16.6845H92.4241V17.4734H88.71V11.0596H92.4241V11.8474Z",
    fill: "white"
  }))), _mask17 || (_mask17 = /*#__PURE__*/React.createElement("mask", {
    id: "mask16",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 123,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 40.0032H137.828V9.30469H15V40.0032Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.4241 11.8474H89.5274V13.8806H92.1389V14.6513H89.5274V16.6845H92.4241V17.4734H88.71V11.0596H92.4241V11.8474Z",
    stroke: "white",
    strokeWidth: 0.2
  }))), _mask18 || (_mask18 = /*#__PURE__*/React.createElement("mask", {
    id: "mask17",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 123,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 40.0032H137.828V9.30469H15V40.0032Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.7041 17.4734V11.0596H94.5216V16.6855H97.2751V17.4734H93.7041Z",
    fill: "white"
  }))), _mask19 || (_mask19 = /*#__PURE__*/React.createElement("mask", {
    id: "mask18",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 123,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 40.0032H137.828V9.30469H15V40.0032Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.7041 17.4734V11.0596H94.5216V16.6855H97.2751V17.4734H93.7041Z",
    stroke: "white",
    strokeWidth: 0.2
  }))), _mask20 || (_mask20 = /*#__PURE__*/React.createElement("mask", {
    id: "mask19",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 123,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 40.0032H137.828V9.30469H15V40.0032Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.438 17.4734V11.0596H101.433L104.525 16.0484H104.561L104.525 14.8127V11.0596H105.343V17.4734H104.49L101.256 12.2418H101.22L101.256 13.4786V17.4734H100.438Z",
    fill: "white"
  }))), _mask21 || (_mask21 = /*#__PURE__*/React.createElement("mask", {
    id: "mask20",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 123,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 40.0032H137.828V9.30469H15V40.0032Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.438 17.4734V11.0596H101.433L104.525 16.0484H104.561L104.525 14.8127V11.0596H105.343V17.4734H104.49L101.256 12.2418H101.22L101.256 13.4786V17.4734H100.438Z",
    stroke: "white",
    strokeWidth: 0.2
  }))), _mask22 || (_mask22 = /*#__PURE__*/React.createElement("mask", {
    id: "mask21",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 123,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 40.0032H137.828V9.30469H15V40.0032Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.668 17.6173C110.598 17.6173 111.375 17.2934 112.001 16.6445C112.625 15.9967 112.938 15.2046 112.938 14.2671C112.938 13.335 112.624 12.544 111.997 11.893C111.368 11.242 110.593 10.917 109.668 10.917C108.738 10.917 107.961 11.2409 107.337 11.8887C106.711 12.5365 106.399 13.3296 106.399 14.2671C106.399 15.2046 106.711 15.9967 107.337 16.6445C107.961 17.2934 108.738 17.6173 109.668 17.6173ZM109.668 16.8284C108.986 16.8284 108.411 16.5889 107.94 16.1079C107.47 15.6269 107.234 15.0133 107.234 14.2671C107.234 13.521 107.47 12.9063 107.94 12.4264C108.411 11.9453 108.986 11.7048 109.668 11.7048C110.349 11.7048 110.926 11.9453 111.396 12.4264C111.867 12.9063 112.104 13.521 112.104 14.2671C112.104 15.0133 111.867 15.6269 111.396 16.1079C110.926 16.5889 110.349 16.8284 109.668 16.8284Z",
    fill: "white"
  }))), _mask23 || (_mask23 = /*#__PURE__*/React.createElement("mask", {
    id: "mask22",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 123,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 40.0032H137.828V9.30469H15V40.0032Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.94 16.1079L107.868 16.1778L107.869 16.1778L107.94 16.1079ZM111.396 16.1079L111.468 16.1778L111.468 16.1778L111.396 16.1079ZM111.396 12.4264L111.325 12.4963L111.325 12.4964L111.396 12.4264ZM107.94 12.4264L107.869 12.3564L107.869 12.3564L107.94 12.4264ZM112.001 16.6445L112.073 16.7139L112.073 16.7139L112.001 16.6445ZM107.337 16.6445L107.409 16.5752L107.409 16.575L107.337 16.6445ZM107.337 11.8887L107.409 11.9581L107.409 11.9581L107.337 11.8887ZM111.997 11.893L112.069 11.8235L112.069 11.8235L111.997 11.893ZM107.869 16.1778C108.358 16.6784 108.96 16.9284 109.668 16.9284V16.7284C109.013 16.7284 108.463 16.4994 108.011 16.0379L107.869 16.1778ZM109.668 16.9284C110.375 16.9284 110.978 16.6784 111.468 16.1778L111.325 16.0379C110.873 16.4994 110.323 16.7284 109.668 16.7284V16.9284ZM111.468 16.1778C111.959 15.6761 112.204 15.0364 112.204 14.2671H112.004C112.004 14.9901 111.776 15.5776 111.325 16.0379L111.468 16.1778ZM112.204 14.2671C112.204 13.4979 111.959 12.8571 111.468 12.3563L111.325 12.4964C111.775 12.9556 112.004 13.5441 112.004 14.2671H112.204ZM111.468 12.3564C110.978 11.8559 110.375 11.6048 109.668 11.6048V11.8048C110.322 11.8048 110.873 12.0348 111.325 12.4963L111.468 12.3564ZM109.668 11.6048C108.96 11.6048 108.358 11.8559 107.869 12.3564L108.011 12.4963C108.463 12.0348 109.013 11.8048 109.668 11.8048V11.6048ZM107.869 12.3564C107.378 12.8572 107.134 13.4979 107.134 14.2671H107.334C107.334 13.5441 107.562 12.9555 108.011 12.4963L107.869 12.3564ZM107.134 14.2671C107.134 15.0364 107.379 15.676 107.868 16.1778L108.012 16.038C107.562 15.5777 107.334 14.9901 107.334 14.2671H107.134ZM111.929 16.5751C111.323 17.2037 110.572 17.5173 109.668 17.5173V17.7173C110.624 17.7173 111.428 17.383 112.073 16.7139L111.929 16.5751ZM109.668 17.5173C108.765 17.5173 108.014 17.2037 107.409 16.5752L107.265 16.7139C107.909 17.383 108.712 17.7173 109.668 17.7173V17.5173ZM107.409 16.575C106.802 15.9468 106.499 15.1799 106.499 14.2671H106.299C106.299 15.2293 106.62 16.0467 107.265 16.714L107.409 16.575ZM106.499 14.2671C106.499 13.3543 106.802 12.5864 107.409 11.9581L107.265 11.8192C106.62 12.4866 106.299 13.305 106.299 14.2671H106.499ZM107.409 11.9581C108.014 11.3306 108.765 11.017 109.668 11.017V10.817C108.712 10.817 107.909 11.1512 107.265 11.8193L107.409 11.9581ZM109.668 11.017C110.566 11.017 111.315 11.3314 111.925 11.9624L112.069 11.8235C111.421 11.1525 110.619 10.817 109.668 10.817V11.017ZM111.925 11.9624C112.534 12.5941 112.838 13.36 112.838 14.2671H113.038C113.038 13.31 112.715 12.4938 112.069 11.8235L111.925 11.9624ZM112.838 14.2671C112.838 15.1799 112.535 15.9468 111.929 16.5751L112.073 16.7139C112.716 16.0467 113.038 15.2294 113.038 14.2671H112.838Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "_checkout/static/media/google.c5d03b4d74483fbea9e6dee2210da02a.svg";
export { ForwardRef as ReactComponent };